import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import { provideLocationState } from "components/utility/hoc/LocationState";
import ReactToPrint from "react-to-print";
import _ from "underscore";

var moment = require("moment");

var CurrentUser = require("lib/account/CurrentUser");
var Features = require("lib/account/Features");

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var WritingActions = require("lib/actions/WritingActions");
var WritingSelectors = require("lib/selectors/WritingSelectors");
var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var DataActions = require("lib/actions/DataActions");
var DataSelectors = require("lib/selectors/DataSelectors");
var UIActions = require("lib/actions/UIActions");
var DisplayToggleControl = require("components/utility/DisplayToggleControl");

var DataControls = require("components/data/DataControls");
var DataRouting = require("lib/routing/DataRouting");

var PaywallModal = require("components/users/teachers/PaywallModal");
var ReactionFeedback = require("components/support/ReactionFeedback");

var Glyphicon = require("components/utility/icons/Glyphicon");
var Spinner = require("components/utility/Spinner");
var EmptyStateContainer = require("components/utility/EmptyStateContainer");
var OnboardingChecklist = require("components/users/teachers/onboarding/OnboardingChecklist");

var DataGoals = require("components/data/subjects/DataGoals");
var DataQuizTables = require("components/data/subjects/DataQuizTables");
var DataBookTables = require("components/data/subjects/DataBookTables");
var DataAnswers = require("components/data/subjects/DataAnswers");
var DataTextTables = require("components/data/subjects/DataTextTables");
var DataLogTables = require("components/data/subjects/DataLogTables");
var DataLogCalendars = require("components/data/subjects/DataLogCalendars");
var DataReadingLevelGraphs = require("components/data/subjects/DataReadingLevelGraphs");
var DataReadingLevels = require("components/data/subjects/DataReadingLevels");
var DataExercises = require("components/data/subjects/DataExercises");
var DataStudentDigest = require("components/users/students/DataStudentDigest");
var DataTableSummary = require("components/data/subjects/shared/DataTableSummary");
var DataEssayTables = require("components/data/subjects/DataEssayTables");

var StudentSelectorSection = require("components/data/StudentSelectorSection");
var DataToggleRouting = require("lib/routing/DataToggleRouting");
var NoActivityBlock = require("components/data/subjects/shared/NoActivityBlock");

var ExpandedStudentActivitiesTable = require("components/writing/activities/ExpandedStudentActivitiesTable")
var TeacherPicksTable = require("components/writing/activities/TeacherPicksTable")
var AllStudentActivitiesTable = require("components/writing/activities/AllStudentActivitiesTable")

var GoalDatesWarning = require("components/notifications/GoalDatesWarning.js")

require("data/data_page.scss");

@provideLocationState(DataRouting.getRouteState)
@connect(
	(state, props) => {
		var userIDs = _.isEmpty(props.locationState.userIDs) ? undefined : props.locationState.userIDs;
		var students = RosterSelectors.students({ state, conditions: { ids: userIDs } });

		

		if (props.locationState.subjectType) {
			var downProps = {};

			// IMPORTANT: If you add to this, also add to DataActions.clearDataLoading
			downProps.loading = WritingSelectors.isLoadingQuizzes({ state, key: 'index', userIDs }) || 
				      ReadingSelectors.isLoadingLogs({ state, key: 'index', userIDs }) || 
					    DataSelectors.isLoadingDigests({ state, key: 'index', userIDs }) || 
					    WritingSelectors.isLoadingAnswers({ state, key: 'index', userIDs }) ||
					    ReadingSelectors.isLoadingReadingLevels({ state, key: 'index', userIDs }) ||
					    RosterSelectors.isLoadingStudents({ state, key: 'index'}) || 
							RosterSelectors.isLoadingStudentLists({ state, key: 'index' }) ||
							RosterSelectors.isLoadingAdmins({ state, key: 'index' })

		} else {
			var downProps = {};
			downProps.loading = RosterSelectors.isLoadingStudents({ state, key: 'index' }) ||
							RosterSelectors.isLoadingStudentLists({ state, key: 'index' }) ||
							RosterSelectors.isLoadingAdmins({ state, key: 'index' })
		}

		downProps.onlyDemoStudents = _.isEmpty(_.select(RosterSelectors.students({ state }), function(student) {
			return !student.demo_for_teacher
		})),

		downProps.showFullData = true // made constant during freemium updates 07/2022
		downProps.showDigitalActivities = Features.isEnabled(Features.DIGITAL_EXERCISES);
		downProps.showLogs = Features.isEnabled(Features.LOG_READING);
		downProps.showScoringDetails = Features.isEnabled(Features.AUTOGRADER_DATA);
		downProps.studentLists = RosterSelectors.nonEmptyStudentLists({ state });
		downProps.students = students;

		// IF STUDENT LIST SELECTED THEN CHANGE EXPECTATIONS
		var studentListID = $wr.getURLParameterByName("student_list")
		if (studentListID && state.studentLists[studentListID]) {
			var expectations_date_spans = state.studentLists[studentListID].expectations_date_spans
		} else {
			var expectations_date_spans = (RosterSelectors.studentLists({ state })[0] || {}).expectations_date_spans
		}
		downProps.expectationsDateSpans = expectations_date_spans

		var studentListID = $wr.getURLParameterByName("student_list")
		if (studentListID) {
			downProps.selectedStudentList = RosterSelectors.nonEmptyStudentLists({ state })[studentListID]
		}	else {
			downProps.selectedStudentList = downProps.studentLists.length > 0 ? downProps.studentLists[0] : null
		}

		return downProps;
	},
	(dispatch, props) => {
		var clearLoading = function() {
			return dispatch(DataActions.clearDataLoading())
		}
		var showHistoricalDataPaywall = function ()  {dispatch(UIActions.showPaywall({ paywall: PaywallModal.HISTORICAL_DATA }))}
		var openLogReadingPaywall = function() {dispatch(UIActions.showPaywall({ paywall: PaywallModal.LOG_READING }))}
		var openExercisesPaywall =  function() {dispatch(UIActions.showPaywall({ paywall: PaywallModal.EXERCISES }))}
		
		var fetchStudents = function() {
			// Loads in stuff we need but didn't get from the loading on App.js
			var embeds = RosterActions.GLOBAL_STUDENT_EMBEDS
			return dispatch(RosterActions.fetchStudents({ embeds }));
		}

		var fetchStudentLists = function() {
			// Loads in stuff we need but didn't get from the loading on App.js
			var embeds = RosterActions.GLOBAL_STUDENT_LIST_EMBEDS
			return dispatch(RosterActions.fetchStudentLists({ embeds }));
		}

		var populateData = function() {
			return Promise.all([
				fetchStudentLists().then( slResponse => {
					return fetchStudents()
				})
			])
		}

		return {
			clearLoading,
			openLogReadingPaywall,
			openExercisesPaywall,
			populateData
		}
	}
)

@providePopulateData({waitForLoad: true})
class DataPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		props.clearLoading(); // Do this before anything renders

		LuckyOrangeClient.tagComponent("DataPage");

		this.printRef = React.createRef();
		
		this.state = { prevLocationState: {} }
	}

	onPageChange(newPage, newPerPage) {
		var stateWithPage = _.extend({}, this.props.locationState, { page: newPage });
		if (newPerPage !== undefined) {
			stateWithPage = _.extend(stateWithPage, { perPage: newPerPage });
		}

		if (stateWithPage.page === 1) {
			// Otherwise it won't be cached correctly
			delete stateWithPage.page;
		}
		this.updateRoute(stateWithPage);
		$wr.setWindowY(0);
	}

	updateRoute(updatedState, keepPrevLocationState) {
		// if route change is not coming from a link within a table,
		// wipe the orig state
		if (keepPrevLocationState != true) {
			this.setState({ prevLocationState: {} })
		}

		this.props.clearLoading().then(() => {
			if (this.props.showFullData) {
				$wr.redirect(DataRouting.getPath(updatedState, "nope"));
			} else {
				$wr.redirect(DataRouting.getPath(_.pick(updatedState, "subjectType", "nope")));
			}			
		})
	}

	// updates orig state to allow users to get back
	// to table view when clicking on link within table
	updateRouteFromTable(updatedState) {
		this.setState({ prevLocationState: { ...this.props.locationState } }, () => {
			this.updateRoute(updatedState, true)
		})		
	}

	renderReactionFeedback() {
		var locationState = this.props.locationState;
		var subjectTypeKey = (locationState.subjectType || "").toLowerCase().replace(/ /g, "-");
		return (
			<ReactionFeedback where={ "data-page-" + subjectTypeKey } 
				textOnly={ false } 
				title={ "Was it easy to find the data you were looking for?" }
				placeholder={ "Your feedback goes here..." }
				component_position={ ReactionFeedback.POSITION_BOTTOM_RIGHT }
				popover_position={ ReactionFeedback.POSITION_BOTTOM_RIGHT } />
		);
	}

	renderNoStudentsEmptyState() {
		var rosterLink = "/roster?addNewStudentsButton=true";
		var emptyActionText = (
			<p className="addStudentsText">
				It looks like you haven't added any students yet.
				<Link to={ rosterLink }> Add students </Link> 
				and their writing data and scores will appear here!
			</p>
		)
		var emptyImgPath = require("empty-state/data-table.png");
		return (
			<EmptyStateContainer actionText={ emptyActionText }
				linkPath={ rosterLink } imagePath={ emptyImgPath } />
		);
	}
	
	renderNoDataEmptyState() {
		var locationState = this.props.locationState;
		var statusText = "";
		if (locationState.userIDs.length == 1) {
			statusText += "This student doesn't";
		} else {
			statusText += "These students don't";
		}

		statusText += " have any " + DataRouting.subjectNoun(locationState.subjectType) +
			" for these options.";
		var emptyImgPath = require("empty-state/data-table.png");
		return (
			<EmptyStateContainer statusText={ statusText }
				imagePath={ emptyImgPath } />
		);
	}

	renderWritingPaywallDisplay() {
		return (
			<div className="dataPaywall">
				Want to see all writing data for your entire class?
				<button className="btn buttonPrimary" onClick={ this.props.showHistoricalDataPaywall }>
					Learn about WR Silver
				</button>
			</div>
		);
	}

	renderBackToTableArrow() {
		var { prevLocationState } = this.state
		var { locationState } = this.props

		// show when we have a previous state or on single quiz display
		if (!_.isEmpty(prevLocationState)) {
			var linkText = prevLocationState.subjectType
			var newLocationState = { ...prevLocationState }
		} else if (locationState.subjectType == DataRouting.SUBJECT_QUIZZES && locationState.quizID) { 
			var linkText = 'Quiz'
			var newLocationState = _.omit({ ...locationState }, 'quizID', 'controlMode')
			newLocationState.subjectType = DataRouting.SUBJECT_QUIZZES
		} else if (locationState.subjectType == DataRouting.SUBJECT_ESSAYS && locationState.essayID) { 
			var linkText = 'Essay'
			var newLocationState = _.omit({ ...locationState }, 'essayID', 'controlMode')
			newLocationState.subjectType = DataRouting.SUBJECT_ESSAYS
		}
		if (newLocationState) {
			return (
				<div className="backArrowContainer">
					<a href="#" onClick={() => this.updateRoute({ ...newLocationState })} className="backArrow btn btn-link">
						<span className='text'>Back</span>
					</a>
				</div>
			)
		}
	}

	renderContent() {
		var displays;
		var locationState = this.props.locationState;
		var vk = $wr.sortedJSON(locationState);
		var studentIDs = _.pluck(this.props.students, 'id');

		var wrapClassName = "contentWrap"

		switch (locationState.subjectType) {

		case DataRouting.SUBJECT_GOALS:
		case DataRouting.SUBJECT_OTHER_METRICS:
			var locationProps = _.pick(locationState, 
				"userIDs", "studentList", "startDate", "endDate"
			);
			var propsProps = _.pick(this.props, "showFullData");
			return (
				<div>
					<DataGoals key={ vk } { ...locationProps } { ...propsProps }
						showTotals
						showGoals={ locationState.subjectType === DataRouting.SUBJECT_GOALS } />
				</div>
			)

		case DataRouting.SUBJECT_QUIZZES:
			var locationProps = _.pick(locationState, 
				"userIDs", "startDate", "endDate", "textVariety", "textID",
				"perPage", "page", "order", "studentList", "quizID", "status"
			);
			var propsProps = _.pick(this.props, "showFullData");
				
			return (
				<DataQuizTables key={vk} {...locationProps} {...propsProps}
					locationState={locationState}
					updateRoute={this.updateRouteFromTable}
					onPageChange={this.onPageChange}
					userIDs={studentIDs}
					prevLocationState={this.state.prevLocationState}
					enabled={{
						date: true,
						student: true,
						score: true,
						textTitle: true,
						readingLevel: true,

						editControls: true,
						feedbackControls: true,
						analysisControls: true,

						allowRevision: true,
						editScore: true,
						deletion: true,
						toggleInclude: true,
					}} />
			)

		case DataRouting.SUBJECT_ANSWERS:
		case DataRouting.SUBJECT_REVIEWS:
		case DataRouting.SUBJECT_WRITING:
		case DataRouting.SUBJECT_QUESTION_BUILDERS:
			var locationProps = _.pick(locationState, 
				"userIDs", "startDate", "endDate", "textVariety", "textID",
				"perPage", "page", "order", "studentList"
			);
			var propsProps = _.pick(this.props, "showFullData");

			var answerType = DataAnswers.ANSWER_TYPE_LOOKUP[locationState.subjectType];

			return (
				<DataAnswers key={ vk } { ...locationProps } { ...propsProps }
					userIDs={studentIDs} answerType={answerType} onPageChange={this.onPageChange}
					prevLocationState={this.state.prevLocationState}  updateRoute={this.updateRoute}
					enabled={{
						date: true,
						student: true,
						score: true,
						linkToQuiz: true,
						textTitle: true,
						readingLevel: true,

						editControls: true,
						feedbackControls: true,
						analysisControls: true,

						allowRevision: true,
						editScore: true,
						deletion: true,
						toggleInclude: true,
					}} />
			);

		case DataRouting.SUBJECT_BOOKS:
			var locationProps = _.pick(locationState, 
				"startDate", "endDate", "textVariety", "textID", "studentList", "readBook"
			);
			var propsProps = _.pick(this.props, "showFullData");
			
			return (
				<DataBookTables key={vk} {...locationProps} {...propsProps}
					softMaxPerTable={10}
					locationState={locationState}
					updateRoute={this.updateRouteFromTable}
					prevLocationState={this.state.prevLocationState}
					userIDs={studentIDs} byStudent />
			);

		case DataRouting.SUBJECT_LOG_LIST:
			var locationProps = _.pick(locationState, 
				"startDate", "endDate", "textVariety", "textID", "studentList"
			);
			var propsProps = _.pick(this.props, "showFullData");

			return (
				<DataLogTables key={ vk } { ...locationProps } { ...propsProps }
					softMaxPerTable={ 20 }
					userIDs={ studentIDs } />
			);


		case DataRouting.SUBJECT_LOG_CALENDAR:
			var locationProps = _.pick(locationState, 
				"startDate", "endDate", "textVariety", "textID", "studentList"
			);
			var propsProps = _.pick(this.props, "showFullData");

			return (
				<DataLogCalendars key={ vk } { ...locationProps }
					{ ...propsProps } userIDs={ studentIDs } />
			);

		case DataRouting.SUBJECT_READING_LEVELS:
			var locationProps = _.pick(locationState, "perPage", "page", "order", "studentList");
			var propsProps = _.pick(this.props, "showFullData");
			
			return (
				<DataReadingLevels key={ vk } { ...locationProps }
					{ ...propsProps } onPageChange={ this.onPageChange } userIDs={ studentIDs } />
			);

		case DataRouting.SUBJECT_READING_LEVEL_GRAPH:
			var locationProps = _.pick(locationState, 
				"startDate", "endDate", 
			);
			var propsProps = _.pick(this.props, "showFullData");

			return (
				<DataReadingLevelGraphs key={ vk } { ...locationProps }
					{ ...propsProps } userIDs={ studentIDs } />
			);

			case DataRouting.SUBJECT_ACTIVITIES:
			var locationProps = _.pick(locationState,
				"startDate", "endDate", "textID", "dueDate", "studentList"
			);
				
			var propsProps = _.pick(this.props, "showFullData");

				if (window.location.href.indexOf("everyone") < 0) {
				return (
					<ExpandedStudentActivitiesTable key={ vk } { ...locationProps }
						{ ...propsProps } userIDs={ studentIDs } />
				);
			} else {
				return (
					<AllStudentActivitiesTable key={vk} {...locationProps}
						{...propsProps} userIDs={studentIDs} />
				);
			}

		case DataRouting.SUBJECT_ASSIGNED_EXERCISES:
			var locationProps = _.pick(locationState,
				"startDate", "endDate", "textVariety", "textID", "dueDate", "studentList"
			);
			var propsProps = _.pick(this.props, "showFullData");

			return (
				<ExpandedStudentActivitiesTable key={vk} {...locationProps}
					{...propsProps} userIDs={studentIDs} assigned />
			);

		case DataRouting.SUBJECT_COMPLETED_EXERCISES:
			var locationProps = _.pick(locationState,
				"startDate", "endDate", "textVariety", "textID", "dueDate", "studentList"
			);
			var propsProps = _.pick(this.props, "showFullData");

			return (
				<ExpandedStudentActivitiesTable key={vk} {...locationProps}
					{...propsProps} userIDs={studentIDs} completed />
			);

			case DataRouting.SUBJECT_TEACHER_PICKS:
			var locationProps = _.pick(locationState,
				"startDate", "endDate", "status", "textVariety", "textID", "draft", "dueDate", "studentList"
			);
			var propsProps = _.pick(this.props, "showFullData");

			return (
				<TeacherPicksTable key={vk} {...locationProps}
					{...propsProps} userIDs={studentIDs} teacherPicks />
			);
		
		case DataRouting.SUBJECT_STUDENT_DASHBOARD:
			var locationProps = _.pick(locationState,
				"startDate", "endDate", "dueDate",
			);
				var propsProps = _.pick(this.props, "showFullData");
				var studentID = _.first(studentIDs)

			return (
				<DataStudentDigest key={vk} {...locationProps}
					{...propsProps} studentID={studentID}/>
			);

		case DataRouting.SUBJECT_ESSAYS:
			var locationProps = _.pick(locationState, 
				"userIDs", "startDate", "endDate","perPage", "page", 
				"order", "studentList", "essayID", "status"
			);
			var propsProps = _.pick(this.props, "showFullData");
				
			return (
				<DataEssayTables key={vk} {...locationProps} {...propsProps}
					locationState={locationState}
					updateRoute={this.updateRouteFromTable}
					onPageChange={this.onPageChange}
					userIDs={studentIDs}
					prevLocationState={this.state.prevLocationState}
					enabled={{
						date: true,
						student: true,
						score: true,
						textTitle: true,
						readingLevel: true,

						editControls: true,
						feedbackControls: true,
						analysisControls: true,

						allowRevision: true,
						editScore: true,
						deletion: true,
					}} />
			)	
		
		
		return (
				<div>
					JELLo!ß
				</div>
			)

		default:
			throw "Unknown subject type: " + locationState.subjectType;
		}

		return (
			<div className={ wrapClassName }>
				{ displays }
			</div>
		);
	}

	changeSelection(ids, studentListID) {

		if (this.props.showFullData) {

			var userIDs = this.isDataStudentDigest() ? [_.first(_.keys(ids))] : _.keys(ids) 
			var studentListID = this.isDataStudentDigest() ? null : studentListID

			if (studentListID) {
				var studentList = _.findWhere(this.props.studentLists, {id: studentListID})

				if (studentList) {
					this.setRouteToStudentList(this.props.locationState.subjectType, studentList, "changeselection")
					return
				}
			}
			
			var stateWithPage = _.extend({}, this.props.locationState, {
				userIDs: userIDs,
				studentList: studentListID
			});

			$wr.redirect(DataRouting.getPath(stateWithPage));
		}
	}

	switchActiveView(viewKey) {
		this.switchView({ subjectType: viewKey });
	}

	switchView(change) {

		this.setState({ prevLocationState: {} }) // clear location history on view switch
		var newLocationState = _.extend({}, this.props.locationState, change);

		$wr.redirect(DataRouting.getPath(newLocationState));
	}

	selectSubjectType(subjectType, e) {
		$wr.nope(e);
		this.switchView({ subjectType })
	}

	singleStudentListSelected() {
		var { locationState } = this.props
		return locationState.studentList && locationState.studentList !== 'everyone'
	}

	selectDataStudentDigest(subjectType, e) {
		$wr.nope(e);
		var { locationState, students } = this.props

		if (_.isEmpty(locationState.userIDs) && !this.singleStudentListSelected()) { // no student list, no user ids
			var userID = _.first(_.pluck(students, 'id'))
		} else if (_.isEmpty(locationState.userIDs) && this.singleStudentListSelected()) { // student list, no user ids
			var userID = _.first(_.filter(students, student => {
				return student.student_list_ids.primary == parseInt(locationState.studentList)
			}))
		} else { // student list, user ids
			var userID = _.first(locationState.userIDs)
		}

		this.switchView({subjectType, userIDs: [userID], studentList: null})
	}

	isDataStudentDigest() {
		return this.props.locationState.subjectType == DataRouting.SUBJECT_STUDENT_DASHBOARD
	}

	effectiveData() {
		var locationState = this.props.locationState;
		return locationState;
	}
	headerText(type) {
		var locationState =  this.props.locationState;
		var subjectType = locationState.subjectType;
		var superSubjectType = null;
		if (locationState.subjectType) {
			superSubjectType = DataRouting.getSubjectHeaderType(locationState.subjectType)
		}
		if (superSubjectType == type) {
			if (subjectType == type) {
				var linkText = type;
			} else {
				var linkText = subjectType;
			}	
		} else {
			var linkText = type;
		}
		return linkText;
	}

	handleSummaryCardClick(change) {
		if (change) {
			this.switchView(_.extend({ textVariety: "fiction-and-non-fiction", userIDs: [] }, { ...change }))
		}			
	}

	renderSummary() {
		var { subjectType, studentList } = this.props.locationState;
		var sharedProps = { admin: CurrentUser.get(), studentListID: parseInt(studentList) || null, onClick: this.handleSummaryCardClick }
		switch (subjectType) {
			case DataRouting.SUBJECT_QUIZZES:
				return <DataTableSummary subjectType={'quiz'} {...sharedProps} />
			case DataRouting.SUBJECT_BOOKS:
				return <DataTableSummary subjectType={'book'} {...sharedProps} />
			default:
				return null
		}
	}

	renderStudentSelector() {
		if (!this.isDataStudentDigest()) {
			return (
				<StudentSelectorSection changeSelection={this.changeSelection}
					initialStudentIDs={this.props.locationState.userIDs} showFullData={this.props.showFullData} />
			);
		}
	}

	render() {
		var locationState = this.props.locationState;
		if (this.props.loading) {
			var displayContent = (<Spinner placeholder />);

		} else if (this.props.onlyDemoStudents) {
			var displayContent = this.renderNoStudentsEmptyState();

		} else if (locationState.subjectType) {
			if (!hasData(locationState, this.props)) {
				var displayContent = this.renderNoDataEmptyState();

			} else {
				var displayContent = this.renderContent();
			}
		} 
		// else {
		// 	// Ooph, this isn't very kosher... and shouldn't happen I think?
		// 	this.switchView({ subjectType: "Goals" });
		// }

		var superSubjectType = null;
		if (locationState.subjectType) {
			superSubjectType = DataRouting.getSubjectHeaderType(locationState.subjectType)
			if (superSubjectType == DataRouting.SUBJECT_ACTIVITIES && !Features.isEnabled(Features.DIGITAL_EXERCISES)) {
				superSubjectType = DataRouting.SUBJECT_QUESTION_BUILDERS
			}
			var headerSuffix = "- " + superSubjectType;
		}
		var onboardingChecklist = <OnboardingChecklist />;

		var goalsSubjectOps = _.map(DataRouting.getSubjectSubtypes(DataRouting.SUBJECT_GOALS), (subjectType) => {
			var className = "";
			var lockIcon = undefined;
			return (
				<li key={ subjectType } className={ className }>
					<a href="#" onClick={ this.selectSubjectType.bind(this, subjectType) }>{ lockIcon }{ subjectType }</a>
				</li>
			);
		})
		var booksSubjectOps = _.map(DataRouting.getSubjectSubtypes(DataRouting.SUBJECT_BOOKS), (subjectType) => {
			var className = "";
			var lockIcon = undefined;
			return (
				<li key={ subjectType } className={ className }>
					<a href="#" onClick={ this.selectSubjectType.bind(this, subjectType) }>{ lockIcon }{ subjectType }</a>
				</li>
			);
		})
		var quizzesSubjectOps = _.map(DataRouting.getSubjectSubtypes(DataRouting.SUBJECT_QUIZZES), (subjectType) => {
			var className = "";
			var lockIcon = undefined;
			return (
				<li key={ subjectType } className={ className }>
					<a href="#" onClick={ this.selectSubjectType.bind(this, subjectType) }>{ lockIcon }{ subjectType }</a>
				</li>
			);
		})
		var writingSubject = DataRouting.SUBJECT_WRITING;
		var writingSubjectOps = _.map(DataRouting.getSubjectSubtypes(writingSubject), (subjectType) => {
			var className = "";
			var lockIcon = undefined;
			return (
				<li key={ subjectType } className={ className }>
					<a href="#" onClick={ this.selectSubjectType.bind(this, subjectType) }>{ lockIcon }{ subjectType }</a>
				</li>
			);
		})
		if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
			var activitiesToShow = DataRouting.getSubjectSubtypes(DataRouting.SUBJECT_ACTIVITIES)
		} else {
			var activitiesToShow = _.filter(DataRouting.getSubjectSubtypes(DataRouting.SUBJECT_ACTIVITIES), (subject) => {
				return subject === DataRouting.SUBJECT_QUESTION_BUILDERS
			})
		}
		var exercisesSubjectOps = _.map(activitiesToShow, (subjectType) => {
				var className = "";
				var lockIcon = undefined;
				return (
					<li key={ subjectType } className={ className }>
						<a href="#" onClick={ this.selectSubjectType.bind(this, subjectType) }>{ lockIcon }{ subjectType }</a>
					</li>
				);
		})

		if (this.props.locationState
			&& this.props.locationState.subjectType
			&& this.props.locationState.subjectType == DataRouting.SUBJECT_QUESTION_BUILDERS
			&& !Features.isEnabled(Features.DIGITAL_EXERCISES))
		{
			var activitiesDropdown = (
				<div className="btn-group" role="group">
					<button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						{ this.headerText(DataRouting.SUBJECT_QUESTION_BUILDERS) }
					</button>
				</div>
			);
		} else {
			var activitiesDropdown = (
				<div className="btn-group" role="group">
					<button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						{ this.headerText(DataRouting.SUBJECT_ACTIVITIES)}
						<span className="caret" ></span>
					</button>
					<ul className="dropdown-menu">
						{ exercisesSubjectOps }
					</ul>
				</div>
			);
		}

		var readingLevelOps = _.map(DataRouting.getSubjectSubtypes(DataRouting.SUBJECT_READING_LEVELS), (subjectType) => {
			var className = "";
			var lockIcon = undefined;
			return (
				<li key={ subjectType } className={ className }>
					<a href="#" onClick={ this.selectSubjectType.bind(this, subjectType) }>{ lockIcon }{ subjectType }</a>
				</li>
			);
		})

		var topControlsDisplay = (
			<div className="hideOnPrint topButtonsContainer">
				<div className="btn-group" role="group">
					<button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
				    	{ this.headerText(DataRouting.SUBJECT_GOALS) }
				    <span className="caret"></span>
				    </button>
					<ul className="dropdown-menu">
				    	{ goalsSubjectOps }
				    </ul>
				</div>
				<div className="btn-group" role="group">
					<button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
				    	{ this.headerText(DataRouting.SUBJECT_BOOKS) }
				    <span className="caret"></span>
				    </button>
					<ul className="dropdown-menu">
				     	{ booksSubjectOps }
				    </ul>
				</div>
				<div className="btn-group" role="group">
					<button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
				    	{ this.headerText(DataRouting.SUBJECT_QUIZZES) } 
				    <span className="caret"></span>
				    </button>
					<ul className="dropdown-menu">
				      { quizzesSubjectOps }
				    </ul>
				</div>


				<div className="btn-group" role="group">
					<button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
				    	{ this.headerText(DataRouting.SUBJECT_WRITING) } 
				    <span className="caret"></span>
				    </button>
					<ul className="dropdown-menu">
				      { writingSubjectOps }
				    </ul>
				</div>
				{ activitiesDropdown }
				<div className="btn-group">
					<button type="button" className="btn btn-default dataStudentDigestBtn" aria-haspopup="true" aria-expanded="false"
						onClick={this.selectDataStudentDigest.bind(this, DataRouting.SUBJECT_STUDENT_DASHBOARD)}>
						{this.headerText(DataRouting.SUBJECT_STUDENT_DASHBOARD)}
					</button>
				</div>
			</div>
		)

		var dataStudentDigestClass = this.isDataStudentDigest() ? 'dataStudentDigest' : ''

		return (
			<div className="container dataPage">
				{ onboardingChecklist }
				<header className="pageHeader">
					<h1 className="hideOnPrint">Student Data { headerSuffix }</h1>
					<GoalDatesWarning user={CurrentUser.get()} studentLists={this.props.studentLists}/>
				</header>
				{topControlsDisplay}
				{this.renderSummary()}
				{this.renderStudentSelector()}
				<div className={`dataContainer ${dataStudentDigestClass}`}>
					<DataControls
						printRef={this.printRef}
						updateSelectedData={this.updateRoute}
						expectationsDateSpans={this.props.expectationsDateSpans}
						selectedData={locationState}
					/>				
					{this.renderBackToTableArrow()}
					<ReactToPrint
						trigger={() => <div style={{ display: "none" }} />}
						content={() => this.componentRef}
						ref={this.printRef}
					/>
					<div className="dataContent" ref={el => (this.componentRef = el)}>
						{displayContent}
					</div>
				</div>
			</div>
		);
	}

	componentDidUpdate() {
		if (!this.props.loading && !this.props.onlyDemoStudents && !this.props.locationState.subjectType && this.props.studentLists) {
			this.setRouteToStudentList("Goals", this.props.selectedStudentList, "nope")
		}
	}

	componentDidMount() {
		$wr.setWindowY(0);
	}

	setRouteToStudentList(subjectType, studentList) {
		
		if (studentList) {
			if (studentList.expectations_date_spans && studentList.expectations_date_spans.length > 0) {
				var recentDates = studentList.expectations_date_spans[0]
				
				this.switchView({ subjectType: subjectType, studentList: studentList.id, userIDs: studentList.student_ids, startDate: recentDates.start, endDate: recentDates.end});
			} else {
				this.switchView({ subjectType: subjectType, studentList: studentList.id, userIDs: studentList.student_ids});
			}
		}
		
	}

};

function hasData(locationState, props) {
	return true;

	switch (locationState.subjectType) {

	case DataRouting.SUBJECT_GOALS:
		return false; // Temp

	case DataRouting.SUBJECT_QUIZZES:
		return !_.isEmpty(props.quizzes);

	case DataRouting.SUBJECT_ANSWERS:
	case DataRouting.SUBJECT_REVIEWS:
	case DataRouting.SUBJECT_WRITING:
		return !_.isEmpty(props.answers);

	case DataRouting.SUBJECT_ACTIVITIES:
		return !_.isEmpty(props.responses);

	case DataRouting.SUBJECT_ASSIGNED_EXERCISES:
		return !_.isEmpty(props.tasks);

	case DataRouting.SUBJECT_LOG_LIST:
	case DataRouting.SUBJECT_LOG_CALENDAR:
		return !_.isEmpty(props.logs);

	case DataRouting.SUBJECT_BOOKS:
		return !_.isEmpty(props.books);

	case DataRouting.SUBJECT_READING_LEVELS:
		return false;

	case DataRouting.SUBJECT_READING_LEVEL_GRAPH:
		return !(_.isEmpty(props.books) && _.isEmpty(props.readingLevels));

	default:
		// throw "Unknown subject type: " + locationState.subjectType
	}
}

var QUIZZES_VIEW = "quizzes";
var BOOKS_VIEW = "books";
var ANSWERS_VIEW = "answers";
var REVIEWS_VIEW = "reviews";
var WRITING_VIEW = "writing";
var EXERCISES_VIEW = "exercises";

DataPage.WrappedComponent.WrappedComponent.propTypes = PageStrictPropTypes({
	locationState: PropTypes.object.isRequired,

	// Data inserted by @connect
	quizzes: PropTypes.array,
	answers: PropTypes.array,
	responses: PropTypes.array,
	logs: PropTypes.array,
	books: PropTypes.array,
	tasks: PropTypes.array,
	readingLevels: PropTypes.array,
	students: PropTypes.array.isRequired,
	onlyDemoStudents: PropTypes.bool,
	studentList: PropTypes.string,
	prevLocationState: PropTypes.object,
	studentLists: PropTypes.array,
	expectationsDateSpans: PropTypes.array,
	selectedStudentList: PropTypes.object,
	printRef: PropTypes.object,

	// Values inserted by @connect
	loading: PropTypes.bool,
	noStudents: PropTypes.bool,

	showFullData: PropTypes.bool,
	showDigitalActivities: PropTypes.bool,
	showLogs: PropTypes.bool,
	showScoringDetails: PropTypes.bool,

	// Functions inserted by @connect
	showHistoricalDataPaywall: PropTypes.func,
	clearLoading: PropTypes.func.isRequired,
	openLogReadingPaywall: PropTypes.func.isRequired,
	openExercisesPaywall: PropTypes.func.isRequired,
	populateData: PropTypes.func
});

module.exports = DataPage;



// WEBPACK FOOTER //
// ./modules/components/data/DataPage.js